/* eslint-disable prettier/prettier */
import { api } from './axios';

export const UserService = {
  getUsers: () => api.get('/users'),

  createUser: (data: FormData) => api.post('/users', data),

  updateUser: (id: string, data: FormData) => api.patch(`/users/${id}`, data),

  getRoles: () => api.get('/roles'),

  getCompanies: () => api.get('/companies'),

  checkDuplicateEmail: async (email: string) => {
    const res = await api.get(`/users/check-email?email=${email.toLowerCase()}`);
    return res.data.exists;
  },

  createInvitation: async (payload: any) => {
    const res = await api.post('/invitation', payload);
    return res.data;
  },

  acceptInvitation: async (form: any) => {
    return await api.post('/invitation/accept', form);
  },

  getAllInvitations: () => api.get('/invitation'),

  getInvitationById: (id: string) => api.get(`/invitation/by-id/${id}`),

  resendInvitation: (id: string) => api.post(`/invitation/resend/${id}`),
  revokeInvitation: (id: string) => api.patch(`/invitation/${id}/revoke`),

  verifyInvitationToken: async (
    token: string,
  ): Promise<{
    email: string;
    role: string;
    company: string | null;
    expiresAt: string;
  }> => {
    const res = await api.get(`/invitation/${token}`);
    return res.data;
  },

  checkUsernameAvailability: async (username: string) => {
    const response = await api.get(
      `/users/check-username?username=${username.trim().toLowerCase()}`,
    );
    return response.data;
  },

  requestPasswordReset: (email: string) => api.post('/auth/request-password-reset', { email }),

  resetPassword: (data: { token: string; password: string }) =>
    api.post('/auth/reset-password', data),

  verifyResetToken: (token: string) => api.get(`/auth/verify-reset-token/${token}`),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    api.post('/users/change-password', data),

  updateProfile: (formData: FormData) => api.patch('/users/update-profile', formData),

  toggleStatus: (id: string) => api.patch(`/users/${id}/toggle-status`),

};
